import React, { Component } from "react";
import API_URL from '../config';
import { Redirect } from 'react-router';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn
  //MDBIcon,
  //MDBCard,
  //MDBCardBody,
  //MDBModal,
  //MDBModalBody,
  //MDBModalFooter
} from "mdbreact";
//import DocsLink from "./../components/docsLink";
import SectionContainer from "./../components/sectionContainer";
import axios from 'axios';
import logo1 from './logoRemu.jpeg';

// Simula la generación de un captcha aleatorio
const generateCaptcha = () => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let captcha = '';
  for (let i = 0; i < 6; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};

class FormularioEscolaridad extends Component {
    /*
  state = {
    modal: false
  };
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  };
  */
  state = {
    contacts : [],  //activo  
    username: '',//activo
    clave: '',  //activo 
    capcha:generateCaptcha(), // inicializado con captcha
    capchaIngresado: '',  //activo 
    message: '', 
    direccionURL : false,
    hablilitar : '',
    usuarioEnviado : ''//activo
  }

  onChange(e){
    this.setState({
        [e.target.name]:e.target.value
    })
  }

  //llamamos al a funcion tick
  tick() {
    //window.location.reload();
    //this.setState({ username : ''})
    //console.log(this.state.username);
  }
  
//metodo para enviar a la base de datos
onSubmit = (e) =>{
  e.preventDefault(); 
    if (this.state.capchaIngresado === this.state.capcha) 
    {
      //console.log(e);
      //axios.post('http://remuneraciones.unsaac.edu.pe/verificarpassword/'+this.state.username+'/'+ this.state.clave+'',{
      axios.post(API_URL + '/verificarpassword/',{
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': '[your API key----]'
          },
          body: JSON.stringify({
            usuario: this.state.username,
            clave: this.state.clave
          })
        })
        .then((response) => {
          this.setState({ contacts : response.data});
        })
        .catch(error =>{})  
    }
    else
    {
      this.setState({ capchaIngresado : ''})
    }      
      const dato = this.state.username;
      //this.setState({ usuarioEnviado : this.state.username})
      this.setState({ usuarioEnviado : dato})
      this.setState({ username : ''})
      this.setState({ clave : ''})
      this.setState({ capcha:generateCaptcha()})
      this.setState({ capchaIngresado : ''})
} 

  //-----------------------------------------------------------------------------------------------------------------
  // Refresca el captcha
  refreshCaptcha = () => {
    this.setState({ capcha: generateCaptcha() });
  };
//Metodo render
render() {
  // Si viene autenticado desde el Dashboard, redirigir directamente
  const datosFromDashboard = this.props.location && this.props.location.state ? this.props.location.state.datos : null;
  if(datosFromDashboard) {
    return <Redirect push={false} to={{ pathname: '/declaraciones-juradas', state: { datos: datosFromDashboard }}}/>
  }

  if(this.state.contacts.length>0){   
    return <Redirect push={false} to={{ pathname: '/declaraciones-juradas', state: { datos: this.state.contacts }}}/>
    } else {                                
    }  
  return (
    <MDBContainer className="mt-4">
      <br></br>
      <SectionContainer header="Declaracion jurara -  aguinaldo" noBorder>
        <br></br>
        <MDBRow>
    <MDBCol md="2">
    </MDBCol>
          <MDBCol md="4">
            <SectionContainer>
              <form onSubmit = {this.onSubmit}>
                <p className="h5 text-center mb-4">Inicio de sesion</p>
                <div className="grey-text">
                  <MDBInput
                    label="Ingrese su nro. de DNI"
                    icon="envelope"
                    group                      
                    validate
                    error="wrong"
                    success="right"
                    value = {this.state.username} 
                    onChange={this.onChange.bind(this)}
                    name="username" 
                    id="username" 
                    type="text"
                  />
                  <MDBInput 
                    label="Ingrese su contraseña" 
                    icon="lock" 
                    group                     
                    validate 
                    error="wrong"
                    success="right"
                    value = {this.state.clave} 
                    onChange={this.onChange.bind(this)}
                    name="clave" 
                    id="clave" 
                    type="password"                      
                  />
                </div>
<div className="flex items-center justify-between">
  <div className="flex-1 bg-gray-100 p-4 rounded-md text-center">
    <div className="flex justify-center items-center">
      {
        this.state.capcha.split('').map((char, index) => {
          const colors = [
            'text-red-600',
            'text-blue-600',
            'text-green-600',
            'text-purple-600',
            'text-yellow-600',
            'text-pink-600',
            'text-orange-600'
          ];
          const randomColor = colors[Math.floor(Math.random() * colors.length)];
          return (
            <span
              key={index}
              className={`text-6xl font-bold font-mono select-none mx-2 ${randomColor}`}
            >
              {char}
            </span>
          );
        })
      }
    </div>            
  </div>
</div>
                 <MDBInput
                      label="Ingrese codigo de verificación"
                      icon="envelope"
                      group                      
                      validate
                      error="wrong"
                      success="right"
                      value = {this.state.capchaIngresado} 
                      onChange={this.onChange.bind(this)}
                      name="capchaIngresado" 
                      id="capchaIngresado" 
                      type="Text"
                    />

                <div className="text-center">
                  {/* <MDBBtn onClick={this.acceder.bind(this)}>Acceder</MDBBtn> */}
                  <MDBBtn type="submit" color="brown" >Acceder</MDBBtn>
                </div>
              </form>
            </SectionContainer>
          </MDBCol>
          <MDBCol md="6">
            <div>
              <img src={logo1} width="500" height="320" alt="" />
            </div>
          </MDBCol>
        </MDBRow>
      </SectionContainer>

    </MDBContainer>
  );
}
}

export default FormularioEscolaridad;
